import { ChangeDetectorRef, Component } from "@angular/core";
import { SaleAccountingSetting } from "../../model/sale-accounting-setting.model";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";

@Component({
  selector: "ngx-accounting-setting-form",
  templateUrl: "./accounting-setting-form.component.html",
  styleUrls: ["./accounting-setting-form.component.scss"],
})
export class AccountingSettingFormComponent extends BaseFormComponent<SaleAccountingSetting> {
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "SaleAccountingSetting";
    this.label = this.translate("ClientApp.FrontOffice.Financial.AccountingSetting.AccountingSetting");
    super.ngOnInit();
  }

  beforupdate(): void {
    this.model.BranchId = this.accountService.authService.currentBranchId;
  }

  setColumnAttribute(): void {
    if (this.currentrow) {
      const subLedgerType = this.columns.find((x) => x.name === "SubLedgerTypeId");
      if (subLedgerType) subLedgerType.formVisible = false;
    }
  }

  isValid(): boolean {
    if (!this.formGroup.controls["DocumentDescription"].value) {
      this.sts.showDialog("message", "title");
      return false;
    }
    return true;
  }
}
